module.exports = __webpack_public_path__ + "img/manage-benefits.d30df1c9.svg";